import jFormGroup from '@/views/data-manager/jFormGroup';
import jForm from '@/views/data-manager/jForm';
import jFormConfig from '@/views/data-manager/jFormConfig';
import jFormUiList from '@/views/experience-manager/jFormUiList';
// import jFormUi from '@/views/experience-manager/jFormUi';
import jExperienceManager from '@/views/experience-manager-v2/jExperienceManager';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/form-data',
    name: 'jFormGroup',
    component: jFormGroup,
    meta: {
      title: 'Data Manager',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/form-data/table/:id',
    name: 'jForm',
    component: jForm,
    meta: {
      title: 'Data Manager',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/form-data/table/:id/:idTable',
    name: 'jForm',
    component: jForm,
    meta: {
      title: 'Data Manager',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/form-data/table-config/:id',
    name: 'jFormConfig',
    component: jFormConfig,
    meta: {
      title: 'Data Manager',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  // {
  //   path: '/form-ui',
  //   name: 'jFormUIList',
  //   component: jFormUiList,
  //   meta: {
  //     title: 'List Experience Manager',
  //     middleware: [auth, admin, log],
  //     layout: 'jSettingWrapper',
  //   },
  // },
  {
    path: '/experience-manager',
    name: 'jExperienceManagerList',
    component: jFormUiList,
    meta: {
      title: 'List Experience Manager',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  // {
  //   path: '/form-ui/update/:id',
  //   name: 'jFormUi',
  //   component: jFormUi,
  //   meta: {
  //     title: 'Update Experience Manager',
  //     middleware: [auth, admin, log],
  //     layout: 'jSettingWrapper',
  //   },
  // },
  {
    path: '/experience-manager/update/:id',
    name: 'jExperienceManager',
    component: jExperienceManager,
    meta: {
      title: 'Update Experience Manager',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  // {
  //   path: '/multiple-form-ui/update/:id',
  //   name: 'jMultipleFormUi',
  //   component: jFormUi,
  //   meta: {
  //     title: 'Update Multiple Experience Manager',
  //     middleware: [auth, admin, log],
  //     layout: 'jSettingWrapper',
  //   },
  // },
  {
    path: '/multiple-experience-manager/update/:id',
    name: 'jMultipleExperienceManager',
    component: jExperienceManager,
    meta: {
      title: 'Update Multiple Experience Manager',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterForm.js